import { Alert, AlertTitle, Stack } from "@mui/material";
import { FC, useMemo } from "react";
import { useCompanyBlocks } from "src/context/CompanyBlocksContext";
import { isUserAdministrator, isUserCompany } from "src/utils/auth";

const CompanyBlockWarnings: FC = () => {
  const { blockStatus, softBlockStatus } = useCompanyBlocks();
  const shouldShow = useMemo(() => isUserCompany() && !isUserAdministrator(), []);

  if (!shouldShow) {
    return null;
  }

  if (!blockStatus?.is_blocked && !softBlockStatus?.is_blocked) {
    return null;
  }

  return (
    <Stack spacing={2}>
      {blockStatus?.is_blocked && (
        <Alert severity="error">
          <AlertTitle>{blockStatus?.status_message?.title ?? "Status: Essa Empresa Temporariamente Bloqueada."}</AlertTitle>
          {blockStatus?.status_message?.description ?? "Esta conta está temporariamente bloqueada, impossibilitando a realização dos atendimentos."}
        </Alert>
      )}
      {softBlockStatus?.is_blocked && (
        <Alert severity="warning">
          <AlertTitle>
            {softBlockStatus?.status_message?.title ??
              "Sessões do plano bloqueadas (extras liberadas)"}
          </AlertTitle>
          {softBlockStatus?.status_message?.description ??
            "Os colaboradores ainda podem agendar sessões extras pagando por conta própria, mas as sessões incluídas no plano da empresa estão temporariamente bloqueadas."}
        </Alert>
      )}
    </Stack>
  );
};

export default CompanyBlockWarnings;
